import React from 'react';
import { useSelector } from 'react-redux';
import { parsePrice } from '@utils/price-helpers';
import CartIcon from '@components/icons/CartIcon';
import styles from './CartReceiptHeader.module.scss';

const CartReceiptHeader = ({ minicart = false }) => {
	const price = useSelector(state => state.cart.total_price);
	const itemCount = useSelector(state => state.cart.item_count);

	return (
		<div className={`${minicart ? styles.cartHeaderMinicart : styles.cartHeader}`}>
			<span className={styles.myCartLabel}>
				<CartIcon className={styles.cartIcon} pureIcon />
				My Cart:
				<span data-test='my-cart-value' className={`${styles.price} cart-total-price`}>{` $${parsePrice(price)}`}</span>
			</span>
			<p className={`${styles.itemsCount} cart-item-count-minicart`}>({itemCount} items)</p>
		</div>
	);
};

export default CartReceiptHeader;
